const navMenu = document.querySelector(".mobile-menu");
const mobileBtn = document.querySelector(".mobile-btn");

mobileBtn.addEventListener("click", () => {
  mobileBtn.classList.toggle("mobile-btn--active");
  navMenu.classList.toggle("mobile-menu--active");
});

import $ from 'jquery';

$(function () {

  $('.js-open-mobile-submenu').on('click', function () {
    console.log('clicked');
    $(this).next('.mobile-nav__submenu').slideToggle();
    $(this).toggleClass('active');
    
  })

});